module.exports = __webpack_public_path__ + "static/media/icon-new.2704609d.eot";